export default {
    parts: [
        'container',
        'spinnerContainer',
        'spinner',
        'menuButton',
        'trigger',
        'globeIcon',
        'chevronIcon',
        'footerLabel',
        'footerChange',
        'headerCode',
        'menuList',
        'menuItem',
        'menuItemContent',
        'menuItemLabel',
        'menuItemCheck',
        'borderTopNone',
        'drawerTrigger',
        'drawerCode',
        'drawerContent',
        'drawerCloseButton',
        'drawerBody',
        'drawerMenuItem',
        'drawerMenuItemContent',
        'drawerMenuItemLabel',
        'drawerMenuItemCheck'
    ],
    baseStyle: {
        container: {
            zIndex: 1350
        },
        spinnerContainer: {
            textAlign: 'center'
        },
        spinner: {
            size: 'xs',
            color: 'white'
        },
        menuButton: {
            _focusVisible: {
                boxShadow: 'var(--chakra-shadows-outline)'
            }
        },
        trigger: {
            align: 'center',
            ml: 'auto',
            columnGap: 2
        },
        globeIcon: {
            boxSize: 5
        },
        chevronIcon: {
            boxSize: 5,
            color: 'webTypo.textOnColor'
        },
        footerLabel: {
            textStyle: 'bodySmMedium',
            paddingLeft: 1
        },
        footerChange: {
            textStyle: 'bodySmMedium',
            textDecoration: 'underline',
            paddingLeft: 2
        },
        headerCode: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textOnColor'
        },
        menuList: {
            borderRadius: '0',
            padding: '0',
            width: '288px'
        },
        menuItem: {
            color: 'black',
            textStyle: 'bodySmRegular',
            padding: '14px 8px',
            borderTop: '1px solid #ECE9E9',
            _active: {
                backgroundColor: 'transparent'
            },
            _focus: {
                backgroundColor: 'transparent'
            },
            _hover: {
                backgroundColor: 'grey.300'
            }
        },
        menuItemContent: {
            align: 'center',
            width: '100%'
        },
        menuItemLabel: {
            marginRight: 'auto'
        },
        menuItemCheck: {
            marginLeft: 'auto'
        },
        borderTopNone: {
            borderTop: 'none'
        },
        drawerTrigger: {
            alignItems: 'center',
            pointerEvents: 'none'
        },
        drawerCode: {
            fontSize: 'webMd'
        },
        drawerContent: {
            position: 'relative',
            transform: 'translateZ(0)',
            zIndex: 'modal',
            height: {base: '100vh', lg: '100%'},
            sx: {
                '@supports (height: 100dvh)': {
                    height: {base: '100dvh', lg: '100%'}
                }
            }
        },
        drawerCloseButton: {
            position: 'absolute',
            minW: 'auto',
            w: {base: '24px'},
            h: {base: '24px'},
            top: {base: '16px'},
            right: {base: '16px'},
            zIndex: '2',
            backgroundColor: 'transparent',
            _hover: {backgroundColor: 'transparent'},
            color: 'black'
        },
        drawerBody: {
            padding: '56px 0 152px'
        },
        drawerMenuItem: {
            textStyle: 'bodySmRegular',
            color: 'black',
            padding: '13px 8px',
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        drawerMenuItemContent: {
            align: 'center',
            width: '100%'
        },
        drawerMenuItemLabel: {
            marginRight: 'auto'
        },
        drawerMenuItemCheck: {
            marginLeft: 'auto'
        }
    },
    variants: {
        light: {
            headerCode: {
                color: 'webTypo.textPrimary'
            },
            chevronIcon: {
                color: 'webTypo.textPrimary'
            }
        }
    }
}
